import { memo, useEffect, useState } from "react";
import { useAtom, useAtomValue } from 'jotai';
import { mapDataListAtom } from "../../stores/mapStore";
import { Select } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { MapData_Base } from "~/common/typescript/models/MapData";
import { dataTable_selecetedMapData_Atom } from "./store";

const MapDataLayerSelector = () => {
  const mapDataLayers = useAtomValue(mapDataListAtom);
  const [selectedMapData, setSelectedMapData] = useAtom<MapData_Base>(dataTable_selecetedMapData_Atom);
  const [items, setItems] = useState<DefaultOptionType[]>([]);

  useEffect(() => {
    const newItems: DefaultOptionType[] = mapDataLayers.map((layer) => ({
      value: layer.id,
      label: layer.title || layer.name || `Lớp #${layer.id}`,
    }));

    setItems(newItems);
  }, [mapDataLayers]);

  useEffect(() => {
    if (!selectedMapData && mapDataLayers.length > 0) {
      setSelectedMapData(mapDataLayers[0]);
    }
  }, [mapDataLayers, selectedMapData, setSelectedMapData]);

  return (
    <Select
      value={selectedMapData?.id}
      options={items}
      style={{ width: '100%' }}
      placeholder="Chọn lớp bản đồ trong dự án..."
      showSearch
      filterOption={(input, option) =>
        String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      onChange={(value) => {
        const selectedLayer = mapDataLayers.find((layer) => layer.id === value);
        if (selectedLayer) {
          setSelectedMapData(selectedLayer);
        }
      }}
    />
  );
};

export default memo(MapDataLayerSelector);